export const knowledgeLevel = [
  { title: 'html & css', per: '80' },
  { title: 'Sass', per: '85' },
  { title: 'javascript', per: '75' },
  { title: 'typscript', per: '60' },
  { title: 'nextjs', per: '85' },
  { title: 'react.js', per: '76' },
  { title: 'GitHub', per: '80' },
];
